import styled from 'styled-components';

export const PlantingLotsReport = styled.div`
  background: white;
  min-height: 100%;
`
